import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import Paper from '../Paper';
const useStyles = makeStyles()(theme => ({
    wrapper: {
        paddingTop: '0.7rem',
        overflow: 'auto',
        position: 'relative',
        zIndex: theme.zIndex.appBar - 1,
    },
    padLeft: {
        paddingLeft: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
        },
    },
    padBottom: {
        paddingBottom: '0.7rem',
    },
}));
const BreadcrumbsWrapper = ({ children, padLeft = true, padBottom = true, ...rest }) => {
    const { classes, cx } = useStyles();
    return (_jsx(Paper, { className: cx(classes.wrapper, padLeft && classes.padLeft, padBottom && classes.padBottom), elevation: 3, square: true, ...rest, children: children }));
};
export { BreadcrumbsWrapper };
